<!--Header-->
<div class="modal-header text-center" style="color: white;background-color: #0d47a1">
    <h4 class="modal-title w-100">{{x_titulo}}</h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClosemodal()">
      <span aria-hidden="true" class="white-text">&times;</span>
    </button>
</div>

<div class="modal-body">
    <mdb-card>
          <mdb-card-body>
              <div class="form-row mb-3">
                <div class="col-3">Correo Institucional:</div>
                <div class="col-7">
                  <input mdbInput type="text" maxlength="50"  class="form-control" [(ngModel)]="maeUsuarioE.x_usuario" [attr.disabled]="editUser? null : true"  placeholder="">
                </div>
                <div class="col-2">
                    <span>@bnp.gob.pe</span>
                </div>
              </div>
              <div class="form-row mb-3">
                <div class="col-3">Nro. Documento:</div>
                <div class="col-9">
                  <input mdbInput type="text" maxlength="8"  class="form-control" [(ngModel)]="maeUsuarioE.x_nro_documento" placeholder="">
                </div>
              </div>
              <div class="form-row mb-3">
                <div class="col-3">Nombres:</div>
                <div class="col-9">
                  <input mdbInput type="text" maxlength="40"  class="form-control" [(ngModel)]="maeUsuarioE.x_nombres" placeholder="">
                </div>
              </div>
              <div class="form-row mb-3">
                <div class="col-3">Apellido Paterno:</div>
                <div class="col-9">
                  <input mdbInput type="text" maxlength="30"  class="form-control" [(ngModel)]="maeUsuarioE.x_ape_pat" placeholder="">
                </div>
              </div>
              <div class="form-row mb-3">
                <div class="col-3">Apellido Materno:</div>
                <div class="col-9">
                  <input mdbInput type="text" maxlength="30"  class="form-control" [(ngModel)]="maeUsuarioE.x_ape_mat" placeholder="">
                </div>
              </div>
              <div class="form-row mb-3">
                  <div class="col-3">Organo:</div>
                  <div class="col-9">
                    <select class="browser-default custom-select" [(ngModel)]="maeUsuarioE.c_oficina">
                        <option value="0" selected>Seleccione</option>
                        <option *ngFor="let listOrgano of listOrgano" [value]="listOrgano.c_tabla">{{listOrgano.x_valor}}</option>
                    </select>
                  </div>
              </div>
              <div class="form-row mb-3">
                <div class="col-3">Perfil:</div>
                <div class="col-9">
                    <select class="browser-default custom-select" [(ngModel)]="maeUsuarioE.c_perfil" [attr.disabled]="esSuperAdmin ? null : true">
                        <option value="0" selected>Seleccione</option>
                        <option *ngFor="let listPerfil of listPerfil" [value]="listPerfil.c_tabla">{{listPerfil.x_valor}}</option>
                    </select>
                </div>
              </div>
              <div class="form-row mb-3">
                <div class="col-3">Estado:</div>
                <div class="col-9">
                    <select class="browser-default custom-select" [(ngModel)]="maeUsuarioE.c_estado">
                        <option value="0" selected>Seleccione</option>
                        <option *ngFor="let listEstado of listEstado" [value]="listEstado.c_tabla">{{listEstado.x_valor}}</option>
                    </select>
                </div>
              </div>
          </mdb-card-body>
</mdb-card>
<br>
<!--Footer-->
<div class="modal-footer justify-content-center" *ngIf="id!='1'">
  <button mdbBtn type="button" (click)="onGrabar()" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect>
      <mdb-icon fas icon="save" class="mr-1"></mdb-icon>Grabar</button>
</div>

